const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN

module.exports = {
  AUTH_TOKEN
}
